// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IuuPv{padding:30px 45px}.hB6IK{padding:30px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainContainer": `IuuPv`,
	"element": `hB6IK`
};
module.exports = ___CSS_LOADER_EXPORT___;
